import React, { useEffect, useMemo, useRef, useState } from 'react';
import '@stone/scss/components/hero-products/_hero-products.scss';
import SwiperCore, { Navigation, A11y, Keyboard, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import ProductTileSimple from '../product/ProductTileSimple';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import { ButtonNavigation } from '@stone/ui/button/CarouselNavigation';
import classNames from 'classnames';
import useSwiperColGap from '@stone/hooks/useSwiperColGap';
import Image from '@stone/ui/image/Image';
SwiperCore.use([Keyboard, Navigation, A11y, Pagination]);
const IconGalleryEditorialItem = (props) => {
    var _a, _b;
    const { isDesktop } = useMediaQueries();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "product-tile single-slide__img product-tile--SIMPLE", tabIndex: -1, "aria-hidden": "false" },
            React.createElement("div", { className: "product-tile__card" },
                React.createElement("div", { className: "product-tile__image-wrapper" }, props.link_url ? (React.createElement("a", { href: props.link_url, className: "product-tile__link", tabIndex: (isDesktop && props.link_label) || props.disableFocus ? -1 : 0, "aria-hidden": (isDesktop && props.link_label) || props.disableFocus ? true : false },
                    React.createElement(Image, { className: "product-image", src: props.image.path, srcMobile: (_a = props.imageMobile) === null || _a === void 0 ? void 0 : _a.path, alt: "" }))) : (React.createElement("div", { className: "product-tile__link" },
                    React.createElement(Image, { className: "product-image", src: props.image.path, srcMobile: (_b = props.imageMobile) === null || _b === void 0 ? void 0 : _b.path, alt: "" }))))),
            (props.title || props.subtitle || (isDesktop && props.link_label && props.link_url)) && (React.createElement("div", { className: "product-tile__info single-slide__labels" },
                React.createElement("div", { className: "product-tile__info_content" },
                    React.createElement("div", { className: "product-tile__info_base" },
                        React.createElement("div", null, (props.title || props.subtitle) && (React.createElement(React.Fragment, null,
                            props.title && (React.createElement("h3", { className: "product-tile__name" },
                                React.createElement("span", { className: "product-tile__link" }, props.title))),
                            props.subtitle && React.createElement("p", { className: "product-tile__seoname" }, props.subtitle)))),
                        isDesktop && props.link_label && props.link_url && (React.createElement("a", { href: props.link_url, "aria-label": props.link_label_a11n, className: "button button--tertiary product-cta", tabIndex: props.disableFocus ? -1 : undefined, "aria-hidden": props.disableFocus ? true : undefined },
                            React.createElement("span", null, props.link_label))))))))));
};
const IconGalleryCarousel = (props) => {
    var _a, _b, _c, _d;
    const swiperRef = useRef(null);
    const containerRef = useRef(null);
    const gap = useSwiperColGap(swiperRef, 2, 20);
    const [pagination, setPagination] = useState(0);
    const [visibleSlidesIndexes, setVisibleSlidesIndexes] = useState([]);
    const { isDesktop, isTouch, isWideDesktop } = useMediaQueries();
    //@ts-ignore disable-next-line
    const isCarouselTouch = useMemo(() => !isDesktop || (isTouch && !isWideDesktop), [isDesktop, isWideDesktop, isTouch]);
    const paginationIndexes = useMemo(() => {
        var _a, _b;
        return {
            active: Math.round(pagination / 2 + 1)
                .toString()
                .padStart(3, '0'),
            total: Math.round((props.isEditorial ? (_a = props.editorialItems) === null || _a === void 0 ? void 0 : _a.length : (_b = props.products) === null || _b === void 0 ? void 0 : _b.length) / 2)
                .toString()
                .padStart(3, '0'),
        };
    }, [pagination]);
    const swiperProps = {
        spaceBetween: 12,
        breakpoints: {
            [window.mqObj.lg]: {
                slidesPerView: 2,
            },
        },
    };
    useEffect(() => {
        if (containerRef.current) {
            const observer = new ResizeObserver(() => {
                let maxHeight = 0;
                const labels = containerRef.current.querySelectorAll('.product-tile__info');
                labels.forEach((entry) => {
                    if (entry.clientHeight > maxHeight) {
                        maxHeight = entry.clientHeight;
                    }
                });
                const parentId = 'gallery-' + props.id;
                const parent = document.getElementById(parentId);
                parent.style.setProperty('--label-height', `${maxHeight / 10 + 1.2}rem`);
            });
            observer.observe(containerRef.current);
            return () => {
                observer.disconnect();
            };
        }
    }, []);
    const onSlideChange = (swiper) => {
        setPagination(swiper.activeIndex);
        //@ts-ignore disable-next-line
        setVisibleSlidesIndexes(swiper.visibleSlidesIndexes);
    };
    return (React.createElement("div", { className: "container", ref: containerRef },
        React.createElement("div", { className: "row" },
            !isCarouselTouch && (React.createElement("div", { className: "col-lg-2 gallery__carousel-navigation-col" }, (((_a = props.products) === null || _a === void 0 ? void 0 : _a.length) > 2 || ((_b = props === null || props === void 0 ? void 0 : props.editorialItems) === null || _b === void 0 ? void 0 : _b.length) > 2) && React.createElement(ButtonNavigation, { id: `gallery-${props.id}`, type: "prev", isExtended: true }))),
            React.createElement("div", { className: classNames('col-lg-20 gallery__carousel-pagination-col', { 'offset-lg-2': isCarouselTouch }) },
                !isCarouselTouch && (React.createElement("div", { className: "gallery__pagination font__title" },
                    React.createElement("span", null, paginationIndexes.active),
                    React.createElement("span", null, "/"),
                    React.createElement("span", null, paginationIndexes.total))),
                React.createElement(Swiper, Object.assign({ onSwiper: (swiper) => {
                        swiperRef.current = swiper;
                        //@ts-ignore disable-next-line
                        setVisibleSlidesIndexes(swiper.visibleSlidesIndexes);
                    }, onSlideChange: onSlideChange }, props.swiperDefaults, swiperProps, { spaceBetween: isDesktop ? gap : 12, slidesPerGroup: isCarouselTouch ? 1 : 2, navigation: {
                        nextEl: `.gallery-${props.id}-navigation--next`,
                        prevEl: `.gallery-${props.id}-navigation--prev`,
                    } }),
                    !props.isEditorial &&
                        props.products.map((product, i) => (React.createElement(SwiperSlide, { key: product.id, className: "gallery__carousel-slide" }, ({ isActive }) => {
                            var _a;
                            return (React.createElement(ProductTileSimple, { product: product, index: i, showCTA: isDesktop && !props.hideCtas, hidePrice: isDesktop || props.hidePrices, customImage: (_a = product.assetOverride) === null || _a === void 0 ? void 0 : _a.icongallery, disableFocus: isDesktop ? !visibleSlidesIndexes.includes(i) : !isActive }));
                        }))),
                    props.isEditorial &&
                        props.editorialItems.map((product, i) => (React.createElement(SwiperSlide, { key: product.ID, className: "gallery__carousel-slide" }, ({ isActive }) => React.createElement(IconGalleryEditorialItem, Object.assign({}, product, { disableFocus: isDesktop ? !visibleSlidesIndexes.includes(i) : !isActive }))))))),
            !isCarouselTouch && (React.createElement("div", { className: "col-lg-2  gallery__carousel-navigation-col justify-end" }, (((_c = props.products) === null || _c === void 0 ? void 0 : _c.length) > 2 || ((_d = props === null || props === void 0 ? void 0 : props.editorialItems) === null || _d === void 0 ? void 0 : _d.length) > 2) && React.createElement(ButtonNavigation, { id: `gallery-${props.id}`, type: "next", isExtended: true }))))));
};
export default IconGalleryCarousel;
